export const getBrowserVersion = () => {
  if (typeof navigator === "undefined") {
    return "Unknown";
  }

  const userAgent = navigator.userAgent;
  const browserRules: [RegExp, string][] = [
    [/Edg\/(\d+(?:\.\d+)?)/, "Edge"],
    [/Chrome\/(\d+(?:\.\d+)?)/, "Chrome"],
    [/Firefox\/(\d+(?:\.\d+)?)/, "Firefox"],
    [/Version\/(\d+(?:\.\d+)?).*Safari/, "Safari"],
  ];

  for (const [regexp, browserName] of browserRules) {
    const match = userAgent.match(regexp);

    if (match?.[1]) {
      return `${browserName} ${match[1]}`;
    }
  }

  return "Unknown";
};
